<template>
  <v-card class="comentarios-prospecto">
    <!-- Título de la sección -->
    <v-card-title class="pa-4">
      <v-icon small class="mr-2">mdi-chat-multiple</v-icon>
      Comentarios {{ comentarios.length > 0 ? `(${comentarios.length})` : '' }}
    </v-card-title>

    <v-divider></v-divider>

    <!-- Lista de comentarios -->
    <v-card-text class="comentarios-lista pa-4" style="max-height: 400px; overflow-y: auto;">
      <div v-if="comentarios.length === 0" class="text-center text-grey py-4">
        <v-icon>mdi-chat-outline</v-icon>
        <p class="mt-2">No hay comentarios aún</p>
      </div>

      <v-list v-else two-line>
        <v-list-item
          v-for="(comentario, index) in comentarios"
          :key="`comentario-${comentario.id}`"
          class="mb-3"
        >
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold">
              {{ comentario.nombre_usuario }}
            </v-list-item-title>
            <v-list-item-subtitle class="text-xs grey--text">
              {{ formatearFecha(comentario.fecha_hora) }}
            </v-list-item-subtitle>
            <div class="mt-2 text-body2">
              {{ comentario.comentario }}
            </div>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card-text>

    <v-divider></v-divider>

    <!-- Agregar comentario -->
    <v-card-text class="pa-4">
      <v-textarea
        v-model="nuevoComentario"
        outlined
        dense
        label="Escribe un comentario..."
        rows="3"
        placeholder="Escribe tu comentario aquí"
        counter="500"
        maxlength="500"
        @keydown.ctrl.enter="agregarComentario"
        @keydown.meta.enter="agregarComentario"
      ></v-textarea>

      <v-card-actions class="pa-0 mt-2">
        <v-spacer></v-spacer>
        <v-btn
          small
          outlined
          @click="nuevoComentario = ''"
          :disabled="!nuevoComentario.trim() || cargando"
        >
          Limpiar
        </v-btn>
        <v-btn
          small
          color="primary"
          class="ml-2"
          @click="agregarComentario"
          :loading="cargando"
          :disabled="!nuevoComentario.trim() || cargando"
        >
          <v-icon small class="mr-1">mdi-send</v-icon>
          Agregar
        </v-btn>
      </v-card-actions>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ComentariosProspecto',
  props: {
    idProspecto: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      comentarios: [],
      nuevoComentario: '',
      cargando: false,
      error: null
    };
  },
  computed: {
    ...mapGetters('login', ['getdatosUsuarioERPERP'])
  },
  watch: {
    idProspecto: {
      handler() {
        this.cargarComentarios();
      },
      immediate: true
    }
  },
  methods: {
    /**
     * Cargar comentarios desde el servidor
     */
    cargarComentarios() {
      if (!this.idProspecto) return;

      this.cargando = true;
      this.$http
        .get(`/api/comentarios-prospectos/${this.idProspecto}`)
        .then(response => {
          this.comentarios = response.data || [];
          this.error = null;
        })
        .catch(error => {
          console.error('Error al cargar comentarios:', error);
          this.error = (error.response && error.response.data && error.response.data.message) || 'Error al cargar comentarios';
          this.$notify({
            group: 'foo',
            title: 'Error',
            text: this.error,
            type: 'error',
            duration: 3000
          });
        })
        .finally(() => {
          this.cargando = false;
        });
    },

    /**
     * Agregar nuevo comentario
     */
    agregarComentario() {
      // Validación
      if (!this.nuevoComentario.trim()) {
        this.$notify({
          group: 'foo',
          title: 'Validación',
          text: 'El comentario no puede estar vacío',
          type: 'warning',
          duration: 2000
        });
        return;
      }

      this.cargando = true;

      const datosComentario = {
        id_prospecto: this.idProspecto,
        comentario: this.nuevoComentario.trim(),
        nombre_usuario: (this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.nombre_completo) || 'Usuario'
      };

      this.$http
        .post('/api/comentarios-prospectos', datosComentario)
        .then(response => {
          // Limpiar input
          this.nuevoComentario = '';
          
          // Recargar comentarios
          this.cargarComentarios();
          
          this.$notify({
            group: 'foo',
            title: 'Éxito',
            text: 'Comentario agregado correctamente',
            type: 'success',
            duration: 2000
          });
        })
        .catch(error => {
          console.error('Error al agregar comentario:', error);
          const mensaje = (error.response && error.response.data && error.response.data.message) || 'Error al agregar el comentario';
          this.error = mensaje;
          
          this.$notify({
            group: 'foo',
            title: 'Error',
            text: mensaje,
            type: 'error',
            duration: 3000
          });
        })
        .finally(() => {
          this.cargando = false;
        });
    },

    /**
     * Formatear fecha para mostrar
     */
    formatearFecha(fecha) {
      if (!fecha) return '';
      
      try {
        const date = new Date(fecha);
        const now = new Date();
        const diffMs = now - date;
        const diffMinutos = Math.floor(diffMs / 60000);
        const diffHoras = Math.floor(diffMs / 3600000);
        const diffDias = Math.floor(diffMs / 86400000);

        if (diffMinutos < 1) {
          return 'Ahora';
        } else if (diffMinutos < 60) {
          return `hace ${diffMinutos} minuto${diffMinutos > 1 ? 's' : ''}`;
        } else if (diffHoras < 24) {
          return `hace ${diffHoras} hora${diffHoras > 1 ? 's' : ''}`;
        } else if (diffDias < 7) {
          return `hace ${diffDias} día${diffDias > 1 ? 's' : ''}`;
        } else {
          return date.toLocaleString('es-ES', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
          });
        }
      } catch (error) {
        return fecha;
      }
    }
  },
  mounted() {
    this.cargarComentarios();
  }
};
</script>

<style scoped>
.comentarios-prospecto {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.comentarios-lista {
  background-color: #f9f9f9;
}

.comentarios-lista .v-list-item {
  padding-left: 0;
  padding-right: 0;
  border-left: 3px solid #e0e0e0;
  padding-left: 12px;
  margin-bottom: 8px;
}

.comentarios-lista .v-list-item:hover {
  background-color: #f0f0f0;
}
</style>
